<template>
    <div class="row">
        <div class="col-sm-12">
          <div class="order-review-content">
            <span class="order-reviewpatient-title">Patient</span>
            <br/>
            <span class="order-reviewpatient-description">{{OrderReturn.patFirstName}} {{OrderReturn.patLastName}}</span>
          </div>
        </div>
        <div class="col-lg-10 offset-lg-1">
            <hr>
        </div>
        <div class="col-sm-12">
          <div class="order-review-border">
<!--          `<div class="col-sm-12">-->
              <div class="order-info-content">
                <span class="order-reviewpatient-title">Order Information</span>
                <div class="row">
                  <div class="col-sm-6"><span style="font-weight: bold;">Lens Design:</span> {{OrderReturn.lensDesignDescription}}</div>
                  <div class="col-sm-6"><span style="font-weight: bold;">Lens Material:</span> {{OrderReturn.lensMaterialDescription}}</div>
                </div>
              </div>
            <div class="col-sm-12">
              <table class="table-rx">
                  <thead>
                      <tr>
                          <th></th>
                          <th class="order-review-label th-responsive">Sphere</th>
                          <th class="order-review-label th-responsive">Cyl</th>
                          <th class="order-review-label th-responsive">Axis</th>
                          <th class="order-review-label th-responsive">Addition</th>
                          <th class="order-review-label th-responsive">Dist. PD</th>
                          <th class="order-review-label th-responsive">Near PD</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td class="order-review-label table-rx-td-title">RE/OD</td>
                          <td class="order-review-description">{{OrderReturn.reSph}}</td>
                          <td class="order-review-description">{{OrderReturn.reCyl}}</td>
                          <td class="order-review-description">{{OrderReturn.reAxis}}</td>
                          <td class="order-review-description">{{OrderReturn.reAdd}}</td>
                          <td v-if="!OrderReturn.isOnly1DistancePD" class="order-review-description">{{OrderReturn.reDistPD}}</td>
                          <td v-else rowspan="2" class="order-review-description">
                              <p style="margin-top:20px;">{{OrderReturn.distancePD}}</p>
                          </td>
                          <td v-if="!OrderReturn.isOnly1NearPD" class="order-review-description">{{OrderReturn.reNearPD}}</td>
                          <td v-else rowspan="2" class="order-review-description">
                              <p style="margin-top:20px;">{{OrderReturn.nearPD}}</p>
                          </td>
                      </tr>
                      <tr>
                          <td class="order-review-label table-rx-td-title">LE/OS</td>
                          <td class="order-review-description">{{OrderReturn.leSph}}</td>
                          <td class="order-review-description">{{OrderReturn.leCyl}}</td>
                          <td class="order-review-description">{{OrderReturn.leAxis}}</td>
                          <td class="order-review-description">{{OrderReturn.leAdd}}</td>
                          <td v-if="!OrderReturn.isOnly1DistancePD" class="order-review-description">{{OrderReturn.leDistPD}}</td>
                          <td v-if="!OrderReturn.isOnly1NearPD" class="order-review-description">{{OrderReturn.leNearPD}}</td>
                      </tr>
                      <tr>
                          <th></th>
                          <th class="order-review-label th-responsive">Seg Height</th>
                          <th class="order-review-label th-responsive">OC Height</th>
                          <th class="order-review-label th-responsive">H Prism</th>
                          <th class="order-review-label th-responsive">Base</th>
                          <th class="order-review-label th-responsive">V Prism</th>
                          <th class="order-review-label th-responsive">Base</th>
                      </tr>
                      <tr>
                          <td class="order-review-label table-rx-td-title">RE/OD</td>
                          <td class="order-review-description">{{OrderReturn.reSegHeight}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.reocHeight}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.reHorizontalPrismValue}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.reHorizontalPrismDirection}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.reVerticalPrismValue}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.reVerticalPrismDirection}}</td>
                      </tr>
                      <tr>
                          <td class="order-review-label table-rx-td-title">LE/OS</td>
                          <td class="order-review-description">{{OrderReturn.leSegHeight}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.leocHeight}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.leHorizontalPrismValue}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.leHorizontalPrismDirection}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.leVerticalPrismValue}}</td>
                          <td v-if="OrderReturn.includeAdditionalRxFields" class="order-review-description">{{OrderReturn.leVerticalPrismDirection}}</td>
                      </tr>
                  </tbody>
              </table>
            </div>

<!--        <div class="col-lg-10 offset-lg-1">-->
<!--            <hr>-->
<!--        </div>-->
          <div class="col-lg-10">
              <div class="row">
  <!--                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">-->
  <!--                    <div class="form-group">-->
  <!--                        <label class="order-review-label">Lens Design:</label>-->
  <!--                        <span class="order-review-description">{{OrderReturn.lensDesignDescription}}</span>-->
  <!--                    </div>-->
  <!--                </div>-->
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="form-group">
                          <label class="order-review-label">Lens Treatment:</label>
                          <div class="order-review-description" v-for="tr in OrderReturn.lensTreatmentDescription">{{tr}} </div>
                      </div>
                  </div>
  <!--                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">-->
  <!--                    <div class="form-group">-->
  <!--                        <label class="order-review-label">Lens Material:</label>-->
  <!--                        <span class="order-review-description">{{OrderReturn.lensMaterialDescription}}</span>-->
  <!--                    </div>-->
  <!--                </div>-->
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group">
                          <label class="order-review-label">Special Instructions:</label>
                          {{ OrderReturn.specialInstructions1 }}
  <!--                        <textarea v-model="OrderReturn.specialInstructions1" row="3" class="form-control order-review-description" disabled></textarea>-->
                      </div>
                  </div>
              </div>
          </div>

<!--        <div class="col-lg-10 offset-lg-1">-->
<!--            <hr>-->
<!--        </div>-->
          <div class="col-lg-10">
              <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group g-mb-0">
                          <label class="order-review-label">Frame:</label>
                          <span class="order-review-description">{{OrderReturn.frameManufacturer}}, {{OrderReturn.frameBrand}} {{OrderReturn.frameModel}}, {{OrderReturn.frameEyeSize}}-{{OrderReturn.frameTempleLength}}, {{OrderReturn.frameColor}}</span>
                      </div>
                  </div>
                  <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div class="form-group g-mb-0">
                          <label class="order-review-label">Frame Type:</label>
                          <span class="order-review-description"> {{OrderReturn.frameTypeDescription}}</span>
                      </div>
                  </div> -->
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group g-mb-0">
                          <label class="order-review-label">Job Type:</label>
                          <span class="order-review-description">{{OrderReturn.jobTypeDescription}}</span>
                      </div>
                  </div>
              </div>
            </div>
<!--            <div class="col-lg-10 offset-lg-1">-->
<!--                <hr>-->
<!--            </div>-->
          <div class="col-lg-10">
              <div class="row">
                  <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                    <label class="order-review-label">Shipping Address:</label>
                  </div>
                  <div class="col-lg-6 col-md-7 col-sm-12 col-xs-12">
                    <div>
                      <span class="order-review-description">{{OrderReturn.shippingFullName}}</span>
                    </div>
                    <div>
                      <span class="order-review-description">{{OrderReturn.shippingAddressLineOne}}</span>
                    </div>
                    <div>
                      <span class="order-review-description">{{OrderReturn.shippingAddressLineTwo}}</span>
                    </div>
                    <div>
                      <span class="order-review-description">{{OrderReturn.shippingCity}}, {{OrderReturn.shippingState}} {{OrderReturn.shippingPostcode}}</span>
                    </div>
                  </div>
              </div>
          </div>
          <div v-if="MasterAccountType != 'master' && ((Account.isStandardOrderServiceFee && OrderReturn.jobType != 'LSF') || (OrderReturn.jobType == 'LSF' && Account.isFrameLensServiceFee))" class="col-lg-8 offset-lg-2">
              <div class="row">
                  <div class="col-lg-4">
                      <label class="order-review-label">Order Summary:</label>
                  </div>
                  <div class="col-lg-8">
                      <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <span class="order-review-description left">Service Fee</span>
                              <span class="order-review-description right">${{Account.serviceFeeAmount}}</span>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <hr>
                          </div>
                          <div class="col-lg-8">
                              <label class="order-review-label right">Total:</label>
                          </div>
                          <div class="col-lg-4">
                             <span class="order-review-description right">${{Account.serviceFeeAmount}}</span>
                          </div>
                      </div>
                  </div>
                  <div v-if="Voucher.Payment" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing top">
                      <label class="order-review-label">*The voucher provided covers the payment amount for this order.</label>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: ["OrderReturn", "Account", "Voucher"],
  data() {
    return {
        MasterAccountType:null
    };
  },
  methods: {},
  created() {
    console.log(this.OrderReturn);

    console.log(this.Account);

    console.log(this.Voucher);
    this.MasterAccountType = localStorage.getItem("accountType");
  }
};
</script>



// WEBPACK FOOTER //
// OrderReview.vue?483db8bc